import React, { PropTypes } from 'react';
import { pure } from 'recompose';

class ExclusionBox extends React.Component {
  static propTypes = {
    product: PropTypes.number.isRequired,
    answer: PropTypes.object.isRequired,
    exclusion: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange() {
    const { product, answer, exclusion } = this.props;

    this.props.onChange(product, answer, exclusion.order);
  }

  render() {
    const { exclusion, answer } = this.props;

    const checked = exclusion.answers.get(answer.id.toString()) || false;

    return (
      <div className="exclusion">
        <div className="ui checkbox">
          <input
            type="checkbox"
            checked={checked}
            style={{ width: '100%' }}
            onChange={this.handleChange}
          />
          <label />
        </div>
      </div>
    );
  }
}

export default pure(ExclusionBox);



// WEBPACK FOOTER //
// ./src/modules/funnel/components/detail/scoring/ExclusionBox.js